const mediaItems = [
  {
    title: '2024年度高分电影盘点',
    desc: '精选年度 IMDb 与豆瓣双高分佳作，从文艺剧情到商业巨制，一次看够全年最值得关注的十部电影。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20collage%20with%20warm%20golden%20tones%2C%20movie%20reel%20and%20film%20strip%20elements%2C%20soft%20dramatic%20lighting%2C%20elegant%20movie%20poster%20aesthetic%20with%20dark%20background%20and%20amber%20accents%2C%20professional%20cinematography%20style&width=800&height=450&seq=media-card-01&orientation=landscape',
    tag: '年度精选',
  },
  {
    title: '悬疑烧脑片单：高能反转合集',
    desc: '从经典好莱坞悬疑到亚洲烧脑神作，精选20部让你全程屏息的推理与心理惊悚佳作。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20thriller%20atmosphere%20with%20dark%20shadows%20and%20dramatic%20contrast%2C%20film%20noir%20inspired%20visual%2C%20warm%20amber%20light%20through%20window%20blinds%2C%20cinematic%20suspense%20mood%2C%20elegant%20dark%20aesthetic%20with%20subtle%20coral%20highlights&width=800&height=450&seq=media-card-02&orientation=landscape',
    tag: '悬疑专场',
  },
  {
    title: '经典港片回顾：那个黄金年代',
    desc: '重温80、90年代香港电影巅峰时期，从武侠到警匪，每一部都是无法复制的影史经典。',
    img: 'https://readdy.ai/api/search-image?query=Retro%20Hong%20Kong%20cinema%20aesthetic%20with%20neon%20signs%20and%20warm%20street%20lights%2C%20nostalgic%20film%20poster%20collage%2C%20vintage%20movie%20atmosphere%2C%20soft%20grainy%20texture%2C%20warm%20golden%20and%20coral%20color%20palette%2C%20cinematic%20composition&width=800&height=450&seq=media-card-03&orientation=landscape',
    tag: '怀旧经典',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-4 whitespace-nowrap">
            精选推荐
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            编辑精选片单
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            精心策划的主题影单，帮你发现更多值得看的高清免费电影
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.currentTarget as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-4">
                  <span className="px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}